import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'promotions',
            name: 'promotion',
            class: 'Modules\\Site\\Entities\\Promotion'
        }
    }
}